/**
 * Identitas tab untuk jalur MJPEG (§D3.4).
 *
 * Berkas tersendiri, bukan bagian `streamClient`, supaya `api.ts` bisa
 * memakainya tanpa membentuk impor melingkar: `streamClient` butuh `api` untuk
 * mengirim sapaan, sedangkan `api` butuh id ini untuk menyusun URL stream.
 *
 * `sessionStorage`, bukan `localStorage`: id-nya harus **per-tab**. Dua tab
 * milik orang yang sama tidak boleh saling membunuh aliran, dan itu persis yang
 * terjadi kalau id-nya dibagi seluruh browser.
 */
const KEY = 'lensa.clientId';

let cache: string | null = null;

export function clientId(): string {
  if (cache) return cache;
  try {
    const ada = sessionStorage.getItem(KEY);
    if (ada) return (cache = ada);
    const baru = crypto.randomUUID();
    sessionStorage.setItem(KEY, baru);
    return (cache = baru);
  } catch {
    // Mode privat yang mengunci storage, atau konteks tanpa `sessionStorage`.
    // Id acak yang hidup selama halaman terbuka tetap lebih baik daripada tidak
    // punya id sama sekali — server hanya kehilangan kemampuan mengenali tab
    // ini setelah muat ulang, dan penyapu §D3.4 tetap membereskannya.
    return (cache = crypto.randomUUID());
  }
}
